if (!customElements.get('customer-support')) {
  class CustomerSupport extends HTMLElement {
    constructor() {
      super();
      this.toggleBtn = this.querySelector('.cs-toggle-btn');
      this.panel = this.querySelector('.cs-panel');
      this.tooltip = this.querySelector('.cs-tooltip');
      this.tooltipCloseBtn = this.querySelector('.cs-tooltip-close');
      this.isOpen = false;
      this.tooltipTimer = null;
      this.tooltipDismissed = false;
    }

    connectedCallback() {
      this.toggleBtn.addEventListener('click', this.toggle.bind(this));

      this.tooltipCloseBtn?.addEventListener('click', (e) => {
        e.stopPropagation();
        this.hideTooltip();
        this.tooltipDismissed = true;
      });

      document.addEventListener('click', (e) => {
        if (this.isOpen && !this.contains(e.target)) {
          this.close();
        }
      });

      this.initTooltip();
      this.buildLinks();
    }

    toggle() {
      if (this.isOpen) {
        this.close();
      } else {
        this.open();
      }
    }

    open() {
      this.isOpen = true;
      this.classList.add('is-open');
      this.hideTooltip();
      this.tooltipDismissed = true;
    }

    close() {
      this.isOpen = false;
      this.classList.remove('is-open');
    }

    initTooltip() {
      if (!this.tooltip) return;
      const delay = parseInt(this.dataset.tooltipDelay || '3', 10) * 1000;
      this.tooltipTimer = setTimeout(() => {
        if (!this.isOpen && !this.tooltipDismissed) {
          this.showTooltip();
          const autohide = parseInt(this.dataset.tooltipAutohide || '0', 10);
          if (autohide > 0) {
            setTimeout(() => {
              this.hideTooltip();
            }, autohide * 1000);
          }
        }
      }, delay);
    }

    showTooltip() {
      this.tooltip?.classList.add('is-visible');
    }

    hideTooltip() {
      this.tooltip?.classList.remove('is-visible');
      if (this.tooltipTimer) {
        clearTimeout(this.tooltipTimer);
      }
    }

    buildLinks() {
      const links = this.querySelectorAll('.cs-option-link[data-include-url="true"]');
      const currentUrl = window.location.href;

      links.forEach((link) => {
        const type = link.dataset.type;
        let href = link.getAttribute('href') || '';

        if (type === 'whatsapp') {
          const separator = href.includes('?') ? '&' : '?';
          const msg = encodeURIComponent('Hi! I have a question about: ' + currentUrl);
          link.setAttribute('href', href + separator + 'text=' + msg);
        } else if (type === 'email') {
          const separator = href.includes('?') ? '&' : '?';
          const body = encodeURIComponent('Hi, I need help with this page: ' + currentUrl);
          link.setAttribute('href', href + separator + 'body=' + body);
        } else if (type === 'sms') {
          const separator = href.includes('?') ? '&' : '?';
          const body = encodeURIComponent('Hi, I need help with: ' + currentUrl);
          link.setAttribute('href', href + separator + 'body=' + body);
        }
      });
    }
  }

  customElements.define('customer-support', CustomerSupport);
}
